<template>
    <div>
        <section>
            <aside id="leftsidebar" class="sidebar hide-on-large-only">
                <div class="user-info">
                    <div class="image">
                        <img :src="require('@/assets/user.png')" width="48" height="48" alt="User" />
                    </div>
                    <div class="info-container">
                        <div class="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ namaLengkap }}</div>
                        <div class="btn-group user-helper-dropdown">
                            <i class="material-icons" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">keyboard_arrow_down</i>
                            <ul class="dropdown-menu pull-right">
                                <li><a href="javascript:void(0);"><i class="material-icons">person</i>Profile</a></li>
                                <li role="seperator" class="divider"></li>
                                <li><a href="#"><i class="material-icons">input</i>Sign Out</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="menu">
                    <ul class="list">
                        <li class="header">MAIN NAVIGATION</li>
                        <li v-bind:class="{ active: link == 'main/dashboard' }">
                            <a href="#" @click="$router.push('/main/dashboard')" v-waves.button>
                                <i class="material-icons">home</i>
                                <span>Home</span>
                            </a>
                        </li>
                        <li v-if="akses.masterNarasumber" v-bind:class="{ 'active': link == 'main/narasumber' }">
                            <a @click="$router.push('/main/narasumber')" v-waves.button>
                                <i class="material-icons">assignment</i>
                                <span>Master Narasumber</span>
                            </a>
                        </li>
                        <li v-if="akses.userLevel" v-bind:class="{ 'active': link == 'main/admin' }">
                            <a @click="$router.push('/main/admin')" v-waves.button>
                                <i class="material-icons">https</i>
                                <span>User Level</span>
                            </a>
                        </li>
                        <li v-if="akses.anggota" v-bind:class="{ active: fullLink === 'main/anggota' }">
                            <a v-waves.button @click="$router.push('/main/anggota')"><i class="material-icons">person</i><span>Data Anggota</span></a>
                        </li>
                        <li v-if="aksesProfile" v-bind:class="{ active: isProfile }">
                            <a href="javascript:void(0);" @click="isProfile = !isProfile" v-bind:class="{ toggled: isProfile }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">assignment</i>
                                <span>Profile</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isProfile }">
                                <li v-if="akses.profile.visi_misi" v-bind:class="{ active: fullLink === 'main/profile/visi-misi' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/visi-misi' }" @click="$router.push('/main/profile/visi-misi')">Visi Misi</a>
                                </li>
                                <li v-if="akses.profile.sejarah_pendirian" v-bind:class="{ active: fullLink === 'main/profile/sejarah' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/sejarah' }" @click="$router.push('/main/profile/sejarah')">Sejarah Pendirian</a>
                                </li>
                                <li v-if="akses.profile.pendiri" v-bind:class="{ active: fullLink === 'main/profile/pendiri' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/pendiri' }" @click="$router.push('/main/profile/pendiri')">Pendiri</a>
                                </li>
                                <li v-if="akses.profile.dewan_pengawas" v-bind:class="{ active: fullLink === 'main/profile/dewan-pengawas' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/dewan-pengawas' }" @click="$router.push('/main/profile/dewan-pengawas')">Dewan Pengawas</a>
                                </li>
                                <li v-if="akses.profile.pengurus" v-bind:class="{ active: fullLink === 'main/profile/pengurus' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/pengurus' }" @click="$router.push('/main/profile/pengurus')">Pengurus</a>
                                </li>
                                <li v-if="akses.profile.struktur_organisasi" v-bind:class="{ active: fullLink === 'main/profile/struktur-organisasi' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/struktur-organisasi' }" @click="$router.push('/main/profile/struktur-organisasi')">Struktur Organisasi</a>
                                </li>
                                <li v-if="akses.profile.budaya_kerja" v-bind:class="{ active: fullLink === 'main/profile/budaya-kerja' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/profile/budaya-kerja' }" @click="$router.push('/main/profile/budaya-kerja')">Budaya Kerja</a>
                                </li>
                            </ul>
                        </li>
                        <li v-if="aksesLayanan" v-bind:class="{ active: isLayanan }">
                            <a href="javascript:void(0);" @click="isLayanan = !isLayanan" v-bind:class="{ toggled: isLayanan }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">content_copy</i>
                                <span>Layanan</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isLayanan }">
                                <li v-if="akses.layanan.cetak_mp" v-bind:class="{ active: fullLink === 'main/layanan/cetakMP' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/cetakMP' }" @click="$router.push('/main/layanan/cetakMP')">Cetak Struk MP/Pajak</a>
                                </li>
                                <!-- <li v-if="akses.layanan.cetak_mp" v-bind:class="{ active: fullLink === 'main/layanan/cetak-struk-mp' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/cetak-struk-mp' }" @click="$router.push('/main/layanan/cetak-struk-mp')">Cetak Struk MP</a>
                                </li> -->
                                <li v-if="akses.layanan.cetak_up" v-bind:class="{ active: fullLink === 'main/layanan/cetak-struk-uang-pembinaan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/cetak-struk-uang-pembinaan' }" @click="$router.push('/main/layanan/cetak-struk-uang-pembinaan')">Cetak Struk Uang Pembinaan</a>
                                </li>
                                <li v-if="akses.layanan.cetak_rapel" v-bind:class="{ active: fullLink === 'main/layanan/cetak-struk-rapel' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/cetak-struk-rapel' }" @click="$router.push('/main/layanan/cetak-struk-rapel')">Cetak Struk Rapel Kenaikan</a>
                                </li>
                                <li v-if="akses.layanan.cetak_spt" v-bind:class="{ active: fullLink === 'main/layanan/cetak-spt' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/cetak-spt' }" @click="$router.push('/main/layanan/cetak-spt')">Cetak SPT</a>
                                </li>
                                <li v-if="akses.layanan.atur_ip" v-bind:class="{ active: fullLink === 'main/layanan/atur-ip' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/atur-ip' }" @click="$router.push('/main/layanan/atur-ip')">Atur Identitas Pemotong</a>
                                </li>
                                <li v-if="akses.layanan.survey" v-bind:class="{ active: fullLink === 'main/layanan/survey' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/survey' }" @click="$router.push('/main/layanan/survey')">Survey Pelayanan Pensiun</a>
                                </li>
                                <li v-if="akses.layanan.hasil_survey" v-bind:class="{ active: fullLink === 'main/layanan/survey/hasil' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/survey/hasil' }" @click="$router.push('/main/layanan/survey/hasil')">Hasil Survey Pelayanan Pensiun</a>
                                </li>
                                <li v-if="akses.layanan.data_kelengkapan" v-bind:class="{ active: fullLink === 'main/layanan/kelengkapan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/kelengkapan' }" @click="$router.push('/main/layanan/kelengkapan')">Data Daftar Kelengkapan</a>
                                </li>
                                <li v-if="akses.layanan.data_kelengkapan" v-bind:class="{ active: fullLink === 'main/layanan/KritikdanSaran' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/KritikDanSaran' }" @click="$router.push('/main/layanan/KritikDanSaran')">Kritik</a>
                                </li>
                                <li v-if="akses.layanan.data_kelengkapan" v-bind:class="{ active: fullLink === 'main/layanan/Pengaduan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/layanan/Pengaduan' }" @click="$router.push('/main/layanan/Pengaduan/')">Pengaduan</a>
                                </li>
                            </ul>
                        </li>
                        <li v-if="aksesInformasi" v-bind:class="{ active: isInformasi }">
                            <a href="javascript:void(0);" @click="isInformasi = !isInformasi" v-bind:class="{ toggled: isInformasi }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">assignment</i>
                                <span>Informasi</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isInformasi }">
                                <li v-if="akses.informasi.kegiatan" v-bind:class="{ active: fullLink === 'main/informasi/kegiatan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/kegiatan' }" @click="$router.push('/main/informasi/kegiatan')">Kegiatan</a>
                                </li>
                                <li v-if="akses.informasi.artikel" v-bind:class="{ active: fullLink === 'main/informasi/artikel' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/artikel' }" @click="$router.push('/main/informasi/artikel')">Artikel</a>
                                </li>
                                <li v-if="akses.informasi.perkembangan" v-bind:class="{ active: fullLink === 'main/informasi/perkembangan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/perkembangan' }" @click="$router.push('/main/informasi/perkembangan')">Perkembangan Investasi Semesteran</a>
                                </li>
                                <li v-if="akses.informasi.tahunan" v-bind:class="{ active: fullLink === 'main/informasi/tahunan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/tahunan' }" @click="$router.push('/main/informasi/tahunan')">Laporan Keuangan</a>
                                </li>
                                <li v-if="akses.informasi.lowongan" v-bind:class="{ active: fullLink === 'main/informasi/lowongan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/lowongan' }" @click="$router.push('/main/informasi/lowongan')">Lowongan</a>
                                </li>
                                <li v-if="akses.informasi.galeri" v-bind:class="{ active: fullLink === 'main/informasi/galeri' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/informasi/galeri' }" @click="$router.push('/main/informasi/galeri')">Galeri</a>
                                </li>
                            </ul>
                        </li>
                        <li v-if="aksesUnduh" v-bind:class="{ active: isUnduh }">
                            <a href="javascript:void(0);" @click="isUnduh = !isUnduh" v-bind:class="{ toggled: isUnduh }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">file_download</i>
                                <span>Unduh</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isUnduh }">
                                <li v-if="akses.unduh.pdp" v-bind:class="{ active: fullLink === 'main/unduh/pdp' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/pdp' }" @click="$router.push('/main/unduh/pdp')">PDP</a>
                                </li>
                                <li v-if="akses.unduh.arahan" v-bind:class="{ active: fullLink === 'main/unduh/arahan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/arahan' }" @click="$router.push('/main/unduh/arahan')">Arahan</a>
                                </li>
                                <li v-if="akses.unduh.regulasi" v-bind:class="{ active: fullLink === 'main/unduh/regulasi' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/regulasi' }" @click="$router.push('/main/unduh/regulasi')">Regulasi Dana Pensiun</a>
                                </li>
                                <li v-if="akses.unduh.majalah" v-bind:class="{ active: fullLink === 'main/unduh/majalah' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/majalah' }" @click="$router.push('/main/unduh/majalah')">Booklet Dapenbi</a>
                                </li>
                                <li v-if="akses.unduh.materikomunikasi" v-bind:class="{ active: fullLink === 'main/unduh/materiKomunikasi' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/materiKomunikasi' }" @click="$router.push('/main/unduh/materiKomunikasi')">Materi Komunikasi</a>
                                </li>
                                <li v-if="akses.unduh.laporan" v-bind:class="{ active: fullLink === 'main/unduh/laporan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/laporan' }" @click="$router.push('/main/unduh/laporan')">Laporan Tahunan dan Pengawasan</a>
                                </li>
                                <li v-if="akses.unduh.formulir" v-bind:class="{ active: fullLink === 'main/unduh/formulir' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/unduh/formulir' }" @click="$router.push('/main/unduh/formulir')">Formulir Kepesertaan dan Pelayanan Pensiun</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="javascript:void(0);" @click="isPensiunRegistrasi = !isPensiunRegistrasi" v-bind:class="{ toggled: isPensiunRegistrasi }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">file_download</i>
                                <span>Pensiun Registrasi</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isPensiunRegistrasi }">
                                <li>
                                    <a @click="$router.push('/main/pensiunRegistrasi/pensiuntype')">ListPensiun type</a>
                                </li>
                                <!-- <li v-if="akses.unduh.arahan" v-bind:class="{ active: fullLink === 'main/unduh/arahan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/PensiunRegitrasi/arahan' }" @click="$router.push('/main/pensiunRegistrasi/arahan')">Arahan</a>
                                </li> -->
                                <!-- <li v-if="akses.unduh.regulasi" v-bind:class="{ active: fullLink === 'main/unduh/regulasi' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/PensiunRegitrasi/regulasi' }" @click="$router.push('/main/unduh/regulasi')">Regulasi Dana Pensiun</a>
                                </li>
                                <li v-if="akses.unduh.majalah" v-bind:class="{ active: fullLink === 'main/unduh/majalah' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/PensiunRegitrasi/majalah' }" @click="$router.push('/main/unduh/majalah')">Majalah Dapenbi</a>
                                </li>
                                <li v-if="akses.unduh.laporan" v-bind:class="{ active: fullLink === 'main/unduh/laporan' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/PensiunRegitrasi/laporan' }" @click="$router.push('/main/unduh/laporan')">Laporan</a>
                                </li>
                                <li v-if="akses.unduh.formulir" v-bind:class="{ active: fullLink === 'main/unduh/formulir' }">
                                    <a v-bind:class="{ toggled: fullLink === 'main/PensiunRegitrasi/formulir' }" @click="$router.push('/main/unduh/formulir')">Formulir</a>
                                </li> -->
                            </ul>
                        </li>

                         <li>
                            <a href="javascript:void(0);" @click="isFaq = !isFaq" v-bind:class="{ toggled: isFaq }" class="menu-toggle" v-waves.button>
                                <i class="material-icons">question_answer</i>
                                <span>FAQ</span>
                            </a>
                            <ul class="ml-menu" v-bind:class="{ show: isFaq }">
                                <li>
                                    <a @click="$router.push('/main/faq')"> FAQ</a>
                                </li>
                                <li>
                                    <a @click="$router.push('/main/faq/Categoryfaq')">List FAQ Category</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a @click="$router.push('/main/pengumuman/pengumuman')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span>Pengumuman</span>
                            </a>
                        </li>
                        <!-- <li>
                            <a @click="$router.push('/main/pensiunRegistrasi/pensiuntype')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span></span>
                            </a>
                        </li> -->
                        <!-- <li>
                            <a @click="$router.push('/main/pintasanInformasi')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span>PintasInformasi</span>
                            </a>
                        </li> -->
                        <li>
                            <a @click="$router.push('/main/calender')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span>Kalender</span>
                            </a>
                        </li>
                        <li>
                            <a @click="$router.push('/main/banner')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span>Banner</span>
                            </a>
                        </li>
                        <li>
                            <a @click="$router.push('/main/HakdanWajiban/ListHakdanKewajiban')" v-waves.button>
                                <i class="material-icons">announcement</i>
                                <span>Hak dan Kewajiban Peserta</span>
                            </a>
                        </li>
                        <li v-if="akses.log" v-bind:class="{ active: fullLink === 'main/log' }">
                            <a @click="$router.push('/main/log')" v-waves.button>
                                <i class="material-icons">assignment</i>
                                <span>Log</span>
                            </a>
                        </li>
                        <!-- <li v-if="akses.faq" v-bind:class="{ active: fullLink === 'main/faq' }">
                            <a @click="$router.push('/main/faq')" v-waves.button>
                                <i class="material-icons">question_answer</i>
                                <span>FAQ</span>
                            </a>
                        </li> -->
                        <li v-if="akses.syarat" v-bind:class="{ active: fullLink === 'main/syarat' }">
                            <a @click="$router.push('/main/syarat')" v-waves.button>
                                <i class="material-icons">collections_bookmark</i>
                                <span>Syarat Kepesertaan</span>
                            </a>
                        </li>
                        <li v-if="akses.cara" v-bind:class="{ active: fullLink === 'main/cara' }">
                            <a @click="$router.push('/main/cara')" v-waves.button>
                                <i class="material-icons">accessibility</i>
                                <span>Cara Mendaftar</span>
                            </a>
                        </li>
                        <li v-if="akses.slider" v-bind:class="{ 'active': link == 'main/slider' }">
                            <a @click="$router.push('/main/slider')" v-waves.button>
                                <i class="material-icons">photo_library</i><span>Slider</span>
                            </a>
                        </li>
                        <li v-if="akses.kirimNotifikasi" v-bind:class="{ 'active': link == 'main/notification' }">
                            <a @click="$router.push('/main/notification')" v-waves.button>
                                <i class="material-icons">notifications</i><span>Kirim Notifikasi</span>
                            </a>
                        </li>
                        <li v-if="akses.headline" v-bind:class="{ 'active': link == 'main/headline' }">
                            <a @click="$router.push('/main/headline')" v-waves.button>
                                <i class="material-icons">info_outline</i><span>Headline</span>
                            </a>
                        </li>
                        <li v-if="akses.whistleBlower" v-bind:class="{ 'active': link == 'main/whistleblower' }">
                            <a @click="$router.push('/main/whistleblower')" v-waves.button>
                                <i class="material-icons">message</i>
                                <span>WhistleBlower</span>
                            </a>
                        </li>
                        <li v-if="akses.anakPerusahaan" v-bind:class="{ 'active': link == 'main/anak-perusahaan' }">
                            <a @click="$router.push('/main/anak-perusahaan')" v-waves.button>
                                <i class="material-icons">library_books</i><span>Company & Anak Perusahaan</span>
                            </a>
                        </li>
                        <li v-if="akses.hubungiKami" v-bind:class="{ 'active': link == 'main/hubungi-kami' }">
                            <a @click="$router.push('/main/hubungi-kami')" v-waves.button>
                                <i class="material-icons">local_phone</i>
                                <span>Hubungi Kami</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </aside>
        </section>
    </div>
</template>

<script>
  export default {
    name: 'Sidebar',
    data: function () {
      return {
        modal: false,
        isProfile: false,
        isLayanan: false,
        isInformasi: false,
        isUnduh: false,
        isPensiunRegistrasi: false,
        isFaq: false,
        namaLengkap: localStorage.getItem('namaLengkap'),
        akses: {}
      }
    },
    beforeMount () {
      this.akses = JSON.parse(localStorage.getItem('akses'))
    },
    computed: {
      aksesProfile: function () {
        var t = 0
        Object.entries(this.akses.profile).forEach(
          ([key, value]) => { value ? t++ : 0 }
        )
        return t > 0
      },
      aksesLayanan: function () {
        var t = 0
        Object.entries(this.akses.layanan).forEach(
          ([key, value]) => { value ? t++ : 0 }
        )
        return t > 0
      },
      aksesInformasi: function () {
        var t = 0
        Object.entries(this.akses.informasi).forEach(
          ([key, value]) => { value ? t++ : 0 }
        )
        return t > 0
      },
      aksesUnduh: function () {
        var t = 0
        Object.entries(this.akses.unduh).forEach(
          ([key, value]) => { value ? t++ : 0 }
        )
        return t > 0
      },
      link: function () {
        var link = this.$route.path.toString().split('/')
        var l = link[1] + '/' + link[2]

        if (l === 'main/profile') this.isProfile = true
        if (l === 'main/informasi') this.isInformasi = true
        if (l === 'main/unduh') this.isUnduh = true
        if (l === 'main/layanan') this.isLayanan = true
        if (l === 'main/pensiunRegistrasi') this.isPensiunRegistrasi = true
        if (l === 'main/faq') this.isFaq = true

        console.log(l)

        return l
      },
      fullLink: function () {
        var link = this.$route.path.toString().split('/')
        link.shift()
        return link.join('/')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Sidebar.vue